import { FullPageModule } from '../../../styles/global.styles';
import { FormattedMessage } from 'react-intl';
import { LoadingContainer, LoadingMainMessage } from './loading.styles';
import { LoadingSpinner } from '../../LoadingSpinner/loadingSpinner.component';

export const LoadingComponent = () => {
  return (
    <LoadingContainer>
      <LoadingMainMessage>
        <FormattedMessage id="loading.main" />
      </LoadingMainMessage>
      <LoadingSpinner />
    </LoadingContainer>
  );
};
